
import React, { useEffect } from 'react';
import { Row, Col, Tooltip, Button, OverlayTrigger } from 'react-bootstrap';
import styles from './applicant-names-field.module.scss';
import informationIcon from '../../../../../../assets/information.svg';
import { TextInput, DateInput } from '../../../../../../components/form/form';
import closeBtn from '../../../../../../assets/close.svg';
import { PATTERN_ALPHA_SPACE } from '../../../../../../helpr/constants';

/*
  Render Multiple Dynmic Applicants Form Field
  Pass setNameState to deliver result to order-form
*/
const MultipleApplicantName = ({orderFormState, investorEmail}) => {
  const { forceSetField, getField, getDynamicField, getTextFieldPropsDynamic, setDynamicField } = orderFormState;
  /*
    Add empty applicant names to the applicant list field.
    Will put an applicant list object into the applicantList dynamic form state field
  */

  useEffect(()=>{
    let applicantNames = getDynamicField('applicantNames');
    applicantNames[0] = {
      ...applicantNames[0],
      email: {
        value: investorEmail,
        style: {}
      }
    }
  },[]);

  const required = (name) => <a>{name}<a className={styles['red']}>*</a></a>;
  const addApplicantName = (assoc) => {
    const applicantNames = getDynamicField('applicantNames').concat({
      last_name: {value: '', style: {}},
      first_name: {value: '', style: {}},
      middle_name: {value: '', style: {}},
      date_of_birth: {value: '', style: {}},
      email: {value: '', style: {}}
    });
    forceSetField('applicantAssoc', assoc);
    setDynamicField('applicantNames', applicantNames);
  }

  /*
    Splice the last applicant name.
    Will remove the last applicant name entry.
  */
  const removeApplicantName = (index) => {
    var applicantNames = getDynamicField('applicantNames');
    var array = [...applicantNames];
    array.splice(index, 1);
    setDynamicField('applicantNames', array);
    if(array.length == 1){ forceSetField('applicantAssoc', ''); }
  }

  /*
    Render Names Button for Applicant Names Association
  */
  const renderNamesButton = () => {
    if( getField('applicantAssoc') === '' ) {
      return (
        <>
          <Button className={styles['btn']} onClick={()=>addApplicantName('AND')}>AND</Button>
          <Button className={styles['btn']} onClick={()=>addApplicantName('OR')}>OR</Button>
        </>
      )
    } else {
      return <Button className={styles['btn']} onClick={()=>addApplicantName(getField('applicantAssoc'))}>{getField('applicantAssoc')}</Button>
    }
  }

  return (
    <Col className={styles['multi-fields']}>
      <div className={styles['field']}>
        <div className={styles['field-label']}>
          { required('INVESTOR NAME(S):') }
          <OverlayTrigger overlay={<Tooltip>NOTE: ECS has a maximum of 200 characters.  Accounts held jointly between two parties may be titled with an "and" or an "or" between the account holders' names. If the account is listed as an "and" account, then both/all parties must sign to access the funds. If it is an "or" account, only one of the parties needs to sign.  Unless otherwise expressly indicated, ‘and/or’ accounts shall be presumed co-owned by the parties in equal shares.</Tooltip>}>
            <img src={informationIcon}/>
          </OverlayTrigger>
          <div className={styles['remarks']}>
            <i>(First item in the row will be the primary account.)</i>
          </div>
        </div>
      </div>
      <div>
        { getDynamicField('applicantNames').map((_, index)=>{
          return (
            <>
              <Row className={styles['field-input']}>
                <Col p="0" className={styles['field-input-split']}>
                  <Col md="4" className={styles['lastname']}>
                    <TextInput inputProps={getTextFieldPropsDynamic('applicantNames','last_name',index)} placeholder={"Last Name"} maxLength="150" pattern={PATTERN_ALPHA_SPACE}/>
                  </Col>
                  <Col md="4" className={styles['firstname']}>
                    <TextInput inputProps={getTextFieldPropsDynamic('applicantNames','first_name',index)} placeholder={"First Name"} maxLength="150" pattern={PATTERN_ALPHA_SPACE}/>
                  </Col>
                  <Col md="4" className={styles['middlename']}>
                    <TextInput inputProps={getTextFieldPropsDynamic('applicantNames','middle_name',index)} placeholder={"Middle Name"} maxLength="150" pattern={PATTERN_ALPHA_SPACE}/>
                  </Col>
                </Col>
                <div className={styles['close']}>
                  <img src={closeBtn} onClick={()=>removeApplicantName(index)} hidden={!(index>0)}/>
                </div>
              </Row>
              <Row>
                <Col>
                  <TextInput inputProps={getTextFieldPropsDynamic('applicantNames', 'email', index)} placeholder={"Email"} maxLength="40">
                    {required('EMAIL:')}
                  </TextInput>
                </Col>
                <Col>
                  <DateInput inputProps={getTextFieldPropsDynamic('applicantNames', 'date_of_birth',index)}>
                    {required('DATE OF BIRTH:')}
                  </DateInput>
                </Col>
              </Row>
              <div className={styles['add-button']} hidden={!(index == getDynamicField('applicantNames').length-1)}>
                { renderNamesButton() }
              </div>
            </>
          )
          }) }
      </div>
    </Col>
  )
}

/*
  Render one liner account name for QIB and TRUSTFAO
  applicant types.
*/
const SingleApplicantName = ({ orderFormState, header, placeholder }) => {
  const { getTextFieldProps } = orderFormState;
  return (
    <Col className={styles['multi-fields']}>
      <TextInput inputProps={getTextFieldProps('primaryApplicant')} placeholder={placeholder} maxLength="150">
        { header }
      </TextInput>
    </Col>
  )
}

/*
  Render Applicant Names Field Input
*/
const ApplicantNamesInput = ({ orderFormState, investorEmail }) => {
  const { getField, setDynamicField } = orderFormState;
  let header = 'Business Name:*';
  let placeholder = 'Business Name';

  useEffect(()=>{
    if(getField('investorCategory')!=='INDV'){
      setDynamicField('applicantNames', [{
        last_name: {value: '', style: {}},
        first_name: {value: '', style: {}},
        middle_name: {value: '', style: {}},
        date_of_birth: {value: '', style: {}},
        email: {value: investorEmail, style: {}}
      }]);
    }
  },[getField('investorCategory')])

  if( getField('investorCategory') === 'INDV' ) {
    return <MultipleApplicantName orderFormState={orderFormState} investorEmail={investorEmail}/>
  }
  if( getField('investorCategory').includes('QIB') ) {
    placeholder = 'Account Name'
    header = 'NAME (QIB):*';
  }
  if( getField('investorCategory').includes('TRUST') ) {
    placeholder = 'Account Name'
    header = 'NAME (TRUSTFAO):*'
  }
  return <SingleApplicantName header={header} placeholder={placeholder} orderFormState={orderFormState}/>
}

export default ApplicantNamesInput;
